import { render, staticRenderFns } from "./attachLibraryTableDialog.vue?vue&type=template&id=5fafeb22&"
import script from "./attachLibraryTableDialog.vue?vue&type=script&lang=js&"
export * from "./attachLibraryTableDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports